export class Operacao{
    unidadeRemuneracaoBndes: string;
    taxaRemuneracaoBndes: number;
    taxaRemuneracaoBasicaBndes: number;
    taxaFatorAlteracao: number;
    taxaIntermedicao: number;
    taxaCustoFinanceiroAdicional: number;
    idCusto: number;
    idUnidadeMonetariaCobranca: number;
    nomeUnidadeMonetariaCobranca: string;
    taxaDeRemuneracaoAgente: number;

    unidadeRemuneracaoBndes2: string;
    taxaRemuneracaoBndes2: number;
    taxaRemuneracaoBasicaBndes2: number;
    taxaFatorAlteracao2: number;
    taxaIntermedicao2: number;
    taxaCustoFinanceiroAdicional2: number;
    idCusto2: number;
    idUnidadeMonetariaCobranca2: number;
    nomeUnidadeMonetariaCobranca2: string;
    taxaDeRemuneracaoAgente2: number;

    unidadeRemuneracaoBndes3: string;
    taxaRemuneracaoBndes3: number;
    taxaRemuneracaoBasicaBndes3: number;
    taxaFatorAlteracao3: number;
    taxaIntermedicao3: number;
    taxaCustoFinanceiroAdicional3: number;
    idCusto3: number;
    idUnidadeMonetariaCobranca3: number;
    nomeUnidadeMonetariaCobranca3: string;
    taxaDeRemuneracaoAgente3: number;

}